import { useQuery } from 'react-query';

import { vendorQuoteLogService } from 'dashboard/services';
import {
  IVendorQuoteImportAttemptLog,
  IVendorQuoteImportAttemptLogRequestPayload,
  IVendorQuoteImportRangeReport,
  IVendorQuoteImportRangeReportRequestPayload,
} from 'dashboard/types';

export const useGetVendorQuoteImportRangeReport = (
  requestPayload: IVendorQuoteImportRangeReportRequestPayload,
  options: { enabled?: boolean } = {}
) => {
  const { enabled = true } = options;

  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    ['vendorQuoteImportRangeReport', requestPayload],
    ({ signal }) => vendorQuoteLogService.getVendorQuoteImportRangeReport(requestPayload, signal),
    {
      enabled,
      keepPreviousData: true,
    }
  );

  return {
    isError,
    isFetching,
    isLoading,
    refetch,
    report: data?.record as IVendorQuoteImportRangeReport,
  };
};

export const useGetVendorQuoteImportAttemptLog = (
  requestPayload: IVendorQuoteImportAttemptLogRequestPayload,
  options: { enabled?: boolean } = {}
) => {
  const { enabled = true } = options;

  const { data, isLoading, isError } = useQuery(
    ['vendorQuoteImportAttemptLog', requestPayload],
    ({ signal }) => vendorQuoteLogService.getVendorQuoteImportAttemptLog(requestPayload, signal),
    { enabled }
  );

  return {
    isError,
    isLoading,
    attemptLog: data?.record as IVendorQuoteImportAttemptLog,
  };
};
